import { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { AttributeEntity } from '../dto/attribute/AttributeEntity';
import { AttributeModel } from '../dto/attribute/AttributeModel';
import { AttributeSearch } from '../dto/attribute/AttributeSearch';
import { BaseResponse } from '../dto/response/BaseResponse';
import { ReadResponse } from '../dto/response/ReadResponse';
import { AttributeChoiceSearch } from '../dto/attributechoice/AttributeChoiceSearch';
import { ApiClient } from '../util/ApiUtility';
import { AttributeDetailEntity } from '../dto/attribute/AttributeDetailEntity';

export const onAttributeDetail = async (attributeId: number) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/' + attributeId
  }
  const response = await ApiClient().request<BaseResponse<AttributeDetailEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onAttributeBasicUpdate = async (attribute: AttributeEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/update',
    data: attribute
  }

  let response = await ApiClient().request<BaseResponse<AttributeEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onDeleteAttributeChoice = async (choiceId?: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/choice/delete/' + choiceId,
  }

  let response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onAttributeSubmit = async (data: AttributeEntity) => {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/init',
      data
    }
    const response = await ApiClient().request<BaseResponse<AttributeEntity>>(requestConfig);
    return response.data;
}

export const onAttributeSearch = async (data: AttributeSearch) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute',
    params: {
      id: data.id,
      name: data.name,
      categoryIds: data.categoryIds,
      offset: data.offset,
      limit: data.limit
    }
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    // var pageable: ReadPageable = response.data.data;
    // const attributes: Array<AttributeEntity> = pageable.beans;

    // for(let e = 0; e < attributes.length; e++) {
    //   const attrbt = attributes[e];
    //   const choiceResponse: ReadResponse = await onAttributeChoiceList(undefined, attrbt.id);

    //   if (choiceResponse.status === 0) {
    //     var choices: Array<AttributeChoiceEntity> = [];
        
    //     for (var i = 0; i < choiceResponse.data.beans.length; i++) {
    //       var choice: AttributeChoiceEntity = choiceResponse.data.beans[i];
    //       choices.push(choice);
    //     }
    //     attributes[e].choices = choices;
    //   }
    // }
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onRemoveChoiceFromAttributeSubmit = async (removeAttributeChoice: AttributeModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute',
    data: removeAttributeChoice
  }
  const response = await ApiClient().request<BaseResponse<AttributeEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onAddAttributeChoiceSubmit = async (addAttributeChoice: AttributeModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute',
    data: addAttributeChoice
  }
  const response = await ApiClient().request<BaseResponse<AttributeEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onAttributeChoiceSearch = async (data: AttributeChoiceSearch) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/choice',
    params: {
      id: data.id,
      attrbtName: data.attrbtName,
      attributeId: data.attributeId,
      offset: data.offset,
      limit: data.limit
    }
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}